import { Route, Routes, useLocation, Navigate } from 'react-router-dom'
import {ChatInit, ChatProvider} from '../../context/chat/Context'
import {ChatsBase} from './ChatsBase'
import {LayoutProvider} from '../../context/layout/Context'
import { PrivateLayout } from '../../layouts/ChatLayout'
import SharedChatBase from './SharedChatBase'

const ChatPage = () => {
  const location = useLocation();

  return (
    <LayoutProvider>
      <ChatProvider>
        <ChatInit>
          <Routes>
            <Route element={<PrivateLayout />}>
              { location.pathname == '/c' || location.pathname.startsWith('/c/') ?
              <>
                <Route index element={<ChatsBase />}/>
                <Route path=":chatId" element={<ChatsBase />}/>
              </>  
              :
              <>
                <Route index element={<Navigate to="/"/>}/>
                <Route path=":sharedChatId" element={<SharedChatBase />}/>
              </>
              }
            </Route>
          </Routes>
        </ChatInit>
      </ChatProvider>
    </LayoutProvider>
  )
}

export default ChatPage
